import { BrowserRouter } from "react-router-dom";
import TrpcProviderReact from "./providers/TrpcProviderReact";

import { QueryProvider } from "./providers/QueryProvider.jsx";

import { Banner, HoverMonitor } from "@proj/components";
import { trpc } from "../utils/trpc.js";

import { BannerPositioner } from "./BannerPositioner.js";

import {
  EnsureVisitorProvider,
  getVisitorPublicId,
} from "./providers/EnsureVisitorProvider.js";
import { useState } from "react";
import { EnsureBrowserSessionIdProvider } from "./providers/EnsureBrowserSessionIdProvider.js";

function Providers({ children }: { children: React.ReactNode }) {
  return (
    <BrowserRouter>
      <QueryProvider>
        <TrpcProviderReact>
          <EnsureVisitorProvider>
            <EnsureBrowserSessionIdProvider>
              {children}
            </EnsureBrowserSessionIdProvider>
          </EnsureVisitorProvider>
        </TrpcProviderReact>
      </QueryProvider>
    </BrowserRouter>
  );
}

function BannerLoader() {
  const [visitorId] = useState(getVisitorPublicId());

  const [bannerQueryInputs, setBannerQueryInputs] = useState({
    clientTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });

  const { data: activeBannersQuery } = trpc.getActiveBanners.useQuery(
    bannerQueryInputs,
    { enabled: !!visitorId, refetchInterval: 0, refetchOnWindowFocus: false }
  );

  const utils = trpc.useContext();

  const { data: globalBannerSettingsQuery } =
    trpc.getGlobalBannerSettings.useQuery(undefined, {
      refetchInterval: 0,
      // refetchOnWindowFocus: true,
    });

  const { mutateAsync: logBannerActionMutation } =
    trpc.logBannerAction.useMutation();

  // const sessionViewedBannerIds =
  //   LocalDb.session.bannerActions
  //     ?.getAll()
  //     .filter((event) => event.action === "viewed") || [];

  // const filterViewedBanners = activeBannersQuery?.banners.filter((banner) => {
  //   const isBannerViewed = sessionViewedBannerIds.some(
  //     (viewedBannerId) => viewedBannerId.bannerId === banner.bannerId
  //   );

  //   return !isBannerViewed;
  // });

  const [dismissedBannerIds, setDismissedBannerIds] = useState<number[]>([]);
  const filteredBanners =
    activeBannersQuery?.banners.filter((banner) => {
      return !dismissedBannerIds.includes(banner.bannerId);
    }) || [];

  return (
    <>
      <style>{`
      @keyframes supabannerFadeIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}
.supabanner-fade-in{ animation: supabannerFadeIn 300ms ease-in-out forwards;}

        `}</style>
      {filteredBanners?.map((banner) => {
        console.log("banner props", { banner });
        return (
          <BannerPositioner
            key={banner.bannerId}
            banner={banner}
            position={
              globalBannerSettingsQuery?.singleBannerPositioningDefault ||
              "push-down"
            }
          >
            <HoverMonitor>
              {({ isHovered }) => {
                return (
                  <Banner
                    key={`banner-${banner.bannerId}`}
                    {...banner}
                    isHovered={isHovered}
                    onDismiss={async () => {
                      setDismissedBannerIds((prev) => [
                        ...prev,
                        banner.bannerId,
                      ]);
                      // LocalDb.local.bannerActions.add({
                      //   bannerId: banner.bannerId,
                      //   action: "dismissed",
                      // });
                      // LocalDb.session.bannerActions.add({
                      //   bannerId: banner.bannerId,
                      //   action: "dismissed",
                      // });
                      await logBannerActionMutation({
                        bannerId: banner.bannerId,
                        actionType: "dismissed",
                      });
                      utils.getActiveBanners.invalidate();
                    }}
                    onMount={() => {
                      // LocalDb.local.bannerActions.add({
                      //   bannerId: banner.bannerId,
                      //   action: "viewed",
                      // });
                      // LocalDb.session.bannerActions.add({
                      //   bannerId: banner.bannerId,
                      //   action: "viewed",
                      // });
                      logBannerActionMutation({
                        bannerId: banner.bannerId,
                        actionType: "viewed",
                      });
                    }}
                  />
                );
              }}
            </HoverMonitor>
          </BannerPositioner>
        );
      })}
    </>
  );
}

export default function App() {
  return (
    <Providers>
      <BannerLoader />
    </Providers>
  );
}
